module.exports = __webpack_public_path__ + "static/media/secondary-home.84bad685.svg";